import qs from 'qs'

export default {
    namespaced: true,
    state: {
        countries_list: []
    },
    mutations: {
        set_list(state, items) {

            state.countries_list = items;

        }
    },
    actions: {
        async getCountries({commit, state}) {
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'get_countries_list',
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            })
                .then((res) => {
                    if (res.data.success) {
                        commit('set_list', res.data.data);


                    }
                }).catch((e) => {
                    console.log('error')
                })
        }
    },
    getters: {
        get_list: (state) => state.countries_list
    }
};